import { inject, Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '../i18n/translate.service';

@Pipe({ name: 'translate', standalone: true, pure: false })
export class TranslatePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(key: string, params?: Record<string, string | number>): string {
    return this.translateService.translate(key, params);
  }
}
